import Box from "@mui/material/Box";
import React from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Typography from "@mui/material/Typography";
import {
  PRIVILEGE_ALL_ORGANIZATIONS,
  PRIVILEGE_ASSIGNABLE_BY,
} from "../../utility/TextLabels";

const Select: React.FC = () => {
  const [selected, setSelected] = React.useState<string[]>(() => []);

  const handleSelection = (
    event: React.MouseEvent<HTMLElement>,
    newSelection: string[]
  ) => {
    setSelected(newSelection);
  };

  const labelStyle = {
    color: "black",
    fontFamily: "Lato",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    marginBottom: 1,
  };

  const boxStyle = {
    borderRadius: "8px",
    border: "3px solid #6680A6",
    color: "#6680A6",
    textAlign: "center",
    fontFamily: "Lato",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
    textTransform: "none",
    "&:not(:first-of-type)": {
      marginLeft: "8px",
    },
  };

  return (
    <>
      <Typography variant="h3" {...labelStyle}>
        {PRIVILEGE_ASSIGNABLE_BY}
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "row" }}>
        <ToggleButtonGroup value={selected} onChange={handleSelection}>
          <ToggleButton value="option1" sx={boxStyle}>
            {PRIVILEGE_ALL_ORGANIZATIONS}
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </>
  );
};

export default Select;
